var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L25,0 L25,4 L30,4 L30,29 L4,29 L4,23 L0,23 Z M2,2 L2,21 L23,21 L23,2 Z M25,6 L25,23 L6,23 L6,27 L28,27 L28,6 Z ",
    fill: "currentColor",
    transform: "translate(1,1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,0 L2,8 L4,8 L4,9 L-2,9 L-2,8 L0,8 L0,3 L-2,3 L-2,2 L-1,2 L-1,1 L0,1 Z ",
    fill: "currentColor",
    transform: "translate(8,8)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,0 L2,8 L4,8 L4,9 L-2,9 L-2,8 L0,8 L0,3 L-2,3 L-2,2 L-1,2 L-1,1 L0,1 Z ",
    fill: "currentColor",
    transform: "translate(18,8)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,0 L2,2 L0,2 Z ",
    fill: "currentColor",
    transform: "translate(13,10)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,0 L2,2 L0,2 Z ",
    fill: "currentColor",
    transform: "translate(13,15)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default __webpack_public_path__ + "static/media/cards.65f87640b7b77d9de51fcd8dce893045.svg";
export { ForwardRef as ReactComponent };